import { Box, BoxProps } from '@chakra-ui/react';

export const ItemCardBody = ({ ...rest }: BoxProps) => {
  return <Box p="4" {...rest} />;
};
